import { List } from "@/components/list/List";
import { Card, Flex } from "antd";
import { useState } from "react";
import { ClientLineDescription } from "../../../../../../client/components/ClientLineDescription";
import { InsuranceContract, LifeInsurance } from "../../../../../types";
import { groupLifeInsurancesByInsuredClient } from "../../../../../utils";
import { InsuranceCollapseView } from "../InsuranceCollapseView";
import { InsurancesToggleAllButton } from "../InsurancesToggleAllButton";
import LifeInsuranceView from "./LifeInsuranceView";

interface Props {
  contract: InsuranceContract<LifeInsurance>;
}

export const LifeInsurancesData = ({ contract }: Props) => {
  const [openedInsurancesKeys, setOpenedInsurancesKeys] = useState<string[]>([]);

  const insuredClientGroups = groupLifeInsurancesByInsuredClient(contract);
  const multipleInsurances = contract.insurances.length > 1;

  return (
    <Flex vertical gap={16}>
      {insuredClientGroups.map(({ client, insurances }) => (
        <Card
          key={client.id}
          title={<ClientLineDescription client={client} />}
          extra={
            <InsurancesToggleAllButton
              insurances={insurances}
              activeKeys={openedInsurancesKeys}
              onActiveKeysChange={setOpenedInsurancesKeys}
            />
          }
        >
          <List
            items={insurances}
            gap={8}
            renderItem={(insurance, index) => (
              <InsuranceCollapseView
                insurance={insurance}
                contract={contract}
                index={index}
                multipleInsurances={multipleInsurances}
                activeKeys={openedInsurancesKeys}
                onActiveKeysChange={setOpenedInsurancesKeys}
              >
                <LifeInsuranceView insurance={insurance} />
              </InsuranceCollapseView>
            )}
          />
        </Card>
      ))}
    </Flex>
  );
};
